import React, { Fragment } from 'react';
import { Container, Row, Col, Input, Button, FormGroup, Progress } from "reactstrap";
import '../Project/Create/Steps/steps.scss';

function CreateAccount() {

    return (
    	<Fragment>
	        <nav id="topbar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				<div className="cont-topbar">
		    					<Button className="btn-back"></Button>
		    					<h3>Create account</h3>
		    				</div>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</nav>
	    	<section id="progress-bar">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
	    					<Progress value={73}></Progress>
		    			</Col>
			    	</Row>
		    	</Container>
	    	</section>
	    	<form className="m-t-20 form-base-dis">
	    		<Container className="builde-cont">
			    	<Row>
		    			<Col xs={{size: 12}}>
		    				{/*CREATE ACCOUNT*/}
		    				{/*<div className="doble-input-vert-cont m-t-30">
			    				<FormGroup floating>
									<Input
										id="firstname"
										name="firstname"
										placeholder="First name"
										type="text"
									/>
									<Label for="firstname">
										First name
									</Label>
							    </FormGroup>
							    <FormGroup floating>
									<Input
										id="lastname"
										name="lastname"
										placeholder="Last name"
										type="text"
									/>
									<Label for="lastname">
										Last name
									</Label>
							    </FormGroup>
						    </div>
		    				<FormGroup floating className="m-t-30">
								<Input
									id="email"
									name="email"
									placeholder="Email"
									type="email"
								/>
								<Label for="email">
									Your email
								</Label>
						    </FormGroup>
		    				<FormGroup floating className="m-t-30">
								<Input
									id="phone"
									name="phone"
									placeholder="Phone"
									type="tel"
								/>
								<Label for="phone">
									Phone
								</Label>
						    </FormGroup>*/}

		    				{/*VERIFY YOUR EMAIL*/}
		    				{/*<FormGroup className="verify-email">
								<Input
									name="verify1"
									type="text"
									placeholder="X"
									maxlength="1"
								/>
								<Input
									name="verify2"
									type="text"
									placeholder="X"
									maxlength="1"
								/>
								<Input
									name="verify3"
									type="text"
									placeholder="X"
									maxlength="1"
								/>
								<Input
									name="verify4"
									type="text"
									placeholder="X"
									maxlength="1"
								/>
								<Input
									name="verify5"
									type="text"
									placeholder="X"
									maxlength="1"
								/>
								<Input
									name="verify6"
									type="text"
									placeholder="X"
									maxlength="1"
									value="3"
									disabled
								/>
						    </FormGroup>
						    <span className="text-mini-info2">Verification code has been sent to your inbox. Please copy it to the input box above.</span>*/}

		    				{/*CREATE YOUR PASSWORD*/}
		    				<FormGroup className="m-t-30">
								<Input
									id="password"
									name="password"
									placeholder="Choose your password"
									type="password"
								/>
						    </FormGroup>
		    				<FormGroup className="m-t-30">
								<Input
									id="repassword"
									name="repassword"
									placeholder="Confirm password"
									type="password"
								/>
						    </FormGroup>

						    <span className="text-mini-info m-t-15">By selecting Agree and continue, I agree to Builde’s <a href="#">Terms of Service</a>, <a href="#">Payments Terms of Service</a> and <a href="#">Nondiscrimination Policy</a> and acknowledge the <a href="#">Privacy Policy</a>.</span>
		    			</Col>
			    	</Row>
		    	</Container>

		    	{/*BUTTON "CONTINUE" */}
    			{/*<Button color="primary" size="lg" className="button-fixed-fullwidth justify-content-end">Continue</Button>*/}
    			{/*<Button color="primary" size="lg" className="button-fixed-fullwidth justify-content-end" disabled>Agree and continue</Button>*/}

		    	{/*LOADING*/}
    			{/*<Button color="primary" size="lg" className="button-fixed-fullwidth"><div class="dot-flashing"></div></Button>*/}

    			{/*VERIFY OK*/}
    			{/*<Button color="primary" size="lg" className="button-fixed-fullwidth"><img src={Ok} className="ok" /></Button>*/}

    			{/*BTN GREEN*/}
    			<Button color="primary" size="lg" className="button-fixed-fullwidth justify-content-end green">Agree and continue</Button>
	    	</form>
    	</Fragment>
    );
}

export default CreateAccount;